import Vue from 'vue';
import CommonComponents from './components/common/common-components';
import TiaraPlugin from './components/common/tiara-plugin';
import Home from './Home.vue';
import { store } from './store/home.js';
import $ from 'jquery';

Vue.use(CommonComponents);
Vue.use(TiaraPlugin, {
	pageName: 'pc_home',
	pageNameDesc: '피씨홈',
});
new Vue({
	el: '#daumContent',
	store,
	render: h => h(Home),
});

$(function () {
	var getParameterByName = function (name, url) {
		if (!url) {
			url = window.location.href;
		}
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	};

	var closeLayer = function () {
		$('body').removeClass('wrong_cafe');
	};

	$(function () {
		if (getParameterByName('ref') == 'wrongcafe') {
			$('body').addClass('wrong_cafe');
			$('#closeCafeLayerBtn').on('click', closeLayer);
		}
	});
});
$(window).on('load', function(){
	$('#cMain').find('.cafe_category .link_category').css('fontSize', '32px')
});
